module.exports = __webpack_public_path__ + "img/item-bg.b84404c8.png";